// extracted by mini-css-extract-plugin
export default {"menu":"MenuTable_menu__p+Gvc","line":"MenuTable_line__miAgO"};